import { useEffect, useState } from "react";
import { endpoints } from "../lib/api";

/**
 * Fetches a public collection from the backend with a graceful fallback.
 * If the backend is unreachable or returns empty, the provided `fallback`
 * array is used so the site never looks broken.
 */
export function useCollection(key, fallback = []) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fn = endpoints[key];
    if (!fn) {
      setLoading(false);
      return;
    }
    fn()
      .then((list) => {
        if (cancelled) return;
        if (Array.isArray(list) && list.length > 0) {
          setData(list);
        } else {
          setData(fallback);
        }
      })
      .catch(() => {
        if (!cancelled) setData(fallback);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { data, loading };
}
